"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Parser = _interopRequireDefault(require("./Parser"));

var SendToMessenger = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(SendToMessenger, _PureComponent);

  function SendToMessenger() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = SendToMessenger.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var handleParse = this.props.handleParse;
    handleParse();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        color = _this$props.color,
        messengerAppId = _this$props.messengerAppId,
        pageId = _this$props.pageId,
        children = _this$props.children,
        dataRef = _this$props.dataRef,
        size = _this$props.size;
    return _react["default"].createElement("div", {
      className: "fb-send-to-messenger",
      messenger_app_id: messengerAppId,
      page_id: pageId,
      "data-color": color,
      "data-size": size,
      "data-ref": dataRef
    }, children);
  };

  return SendToMessenger;
}(_react.PureComponent);

(0, _defineProperty2["default"])(SendToMessenger, "defaultProps", {
  color: undefined,
  size: undefined,
  dataRef: undefined,
  children: undefined
});

var _default = (0, _react.forwardRef)(function (props, ref) {
  return _react["default"].createElement(_Parser["default"], null, function (_ref) {
    var handleParse = _ref.handleParse;
    return _react["default"].createElement(SendToMessenger, (0, _extends2["default"])({}, props, {
      handleParse: handleParse,
      ref: ref
    }));
  });
});

exports["default"] = _default;